module.exports = "<div class=\"header\" fxFlex>\r\n  <h1>{{title}}</h1>\r\n</div>"